import Icon from "../../../../../Icon"

import styles from "./EpsNoResults.module.less"

const EpsNoResults = () => (
  <div className={styles.empty}>
    <Icon type="empty_warning" className={styles.icon} />
    No results found
  </div>
)

export default EpsNoResults
